import { Branded }		from "ts-base/branded";
import { Numbers }		from "ts-base/numbers";
import { Dates }		from "ts-base/dates";
import { Equal }		from "ts-base/equal";
import { Comparator }	from "ts-base/comparator";
import { Numeric }		from "ts-base/numeric/numeric";
import { Duration }		from "ts-base/time/duration";

/** millisecond point in time based on the unix epoch */
export type Instant		= Branded<number, "Instant">;

export namespace Instant {
	export const name		= "Instant";

	export const brand		= Branded.brand<Instant>;
	export const is			= (it:number):it is Instant	=> Number.isInteger(it);

	export const fromEpochMillis	= (it:number):Instant|null	=> Number.isInteger(it) ? brand(it) : null;
	export const toEpochMillis		= (it:Instant):number		=> it;

	export const fromNumber			= fromEpochMillis;
	export const toNumber			= toEpochMillis;

	export const fromDate	= (it:Date):Instant	=> brand(it.getTime());
	export const toDate		= (it:Instant):Date	=> new Date(it);

	export const now		= ():Instant => brand(Dates.now().getTime());
	export const epoch		= brand(0);

	export const later		= (a:Instant, b:Duration):Instant	=> brand(a + b);
	export const earlier	= (a:Instant, b:Duration):Instant	=> brand(a - b);
	export const duration	= (a:Instant, b:Instant):Duration	=> Duration.brand(b - a);

	export const equal:Equal<Instant>			= Numbers.equal;
	export const compare:Comparator<Instant>	= Numbers.compare;
}

// just for type checking
Numeric.typed(Instant);
